module.exports = __webpack_public_path__ + "img/radio_button_checked.7995e9c7.svg";